module.exports = __webpack_public_path__ + "img/dolar-euro.963a62fd.png";